import { createTheme } from "@material-ui/core/styles";

/**
 * Resource Planner design tokens (see docs/design). Mirrors the CSS variables
 * declared in index.css so charts and JS-side styling stay in sync.
 */
export const tokens = {
  canvas: "hsl(220, 20%, 6%)",
  canvasRaised: "hsl(220, 18%, 9%)",
  surface: "rgba(15, 18, 25, 0.6)",
  surface2: "rgba(20, 24, 33, 0.72)",
  hairline: "rgba(255, 255, 255, 0.06)",
  hairlineStrong: "rgba(255, 255, 255, 0.12)",
  fg1: "hsl(220, 14%, 96%)",
  fg2: "hsl(215, 16%, 70%)",
  fg3: "hsl(215, 16%, 50%)",
  primary: "hsl(217, 91%, 60%)",
  accent: "hsl(263, 70%, 58%)",
  ok: "hsl(142, 64%, 48%)",
  warn: "hsl(38, 92%, 56%)",
  crit: "hsl(0, 72%, 58%)",
  info: "hsl(199, 84%, 56%)",
  fontSans: '"DM Sans", ui-sans-serif, system-ui, sans-serif',
  fontMono: '"JetBrains Mono", ui-monospace, Menlo, monospace',
};

export const theme = createTheme({
  palette: {
    type: "dark",
    primary: { main: tokens.primary },
    secondary: { main: tokens.accent },
    error: { main: tokens.crit },
    warning: { main: tokens.warn },
    success: { main: tokens.ok },
    info: { main: tokens.info },
    background: { default: tokens.canvas, paper: tokens.canvasRaised },
    text: { primary: tokens.fg1, secondary: tokens.fg2 },
    divider: tokens.hairline,
  },
  typography: {
    fontFamily: tokens.fontSans,
    h3: { fontFamily: tokens.fontMono, fontWeight: 500 },
    h5: { fontSize: 14, fontWeight: 600, letterSpacing: "-0.01em" },
    caption: { fontFamily: tokens.fontMono, color: tokens.fg2 },
  },
  shape: { borderRadius: 10 },
  props: {
    MuiButton: { disableElevation: true },
    MuiPaper: { elevation: 0 },
  },
  overrides: {
    MuiCard: {
      root: {
        background: tokens.surface,
        border: `1px solid ${tokens.hairline}`,
        borderRadius: 14,
        backdropFilter: "blur(16px) saturate(140%)",
        WebkitBackdropFilter: "blur(16px) saturate(140%)",
        boxShadow: "0 1px 0 rgba(255,255,255,0.04) inset",
      },
    },
    MuiButton: {
      root: { textTransform: "none", fontWeight: 500 },
      outlined: { borderColor: tokens.hairlineStrong },
    },
    MuiTableCell: {
      root: { borderBottom: `1px solid ${tokens.hairline}` },
      head: {
        fontFamily: tokens.fontMono,
        fontSize: 11,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        color: tokens.fg3,
      },
    },
    MuiAccordion: {
      root: {
        background: "transparent",
        boxShadow: "none",
        "&:before": { display: "none" },
      },
    },
    MuiTooltip: {
      tooltip: {
        background: tokens.surface2,
        border: `1px solid ${tokens.hairlineStrong}`,
        backdropFilter: "blur(16px)",
        fontSize: 12,
      },
    },
    MuiChip: {
      root: { borderRadius: 999 },
    },
    MuiBreadcrumbs: {
      root: { fontFamily: tokens.fontMono, fontSize: 12 },
    },
    MuiLinearProgress: {
      root: { height: 2 },
    },
  },
});
